<template>
  <div class="crumbsBox">
    <el-breadcrumb class="app-breadcrumb" separator-class="el-icon-arrow-right">
      <template v-for="(item, index) in levelList">
        <el-breadcrumb-item
          :key="item.path"
          v-if="index != 0"
          :to="item.path + query"
        >
          {{ item.meta.title }}
        </el-breadcrumb-item>
      </template>
    </el-breadcrumb>
    <div class="crumbsRight">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "crumbs",
  data() {
    return {
      levelList: "",
      query: ""
    };
  },
  mounted() {},
  methods: {
    // 面包屑
    getBreadcrumb() {
      console.log(this.$route);
      let matched = this.$route.matched.filter(
        item => item.meta && item.meta.title
      );
      if (matched.length == 4) {
        this.query = "?" + window.location.href.split("?")[1];

        this.levelList = matched;
      } else {
        this.query = "";
        this.levelList = matched;
      }
    }
  },
  watch: {
    $route: {
      handler: function() {
        this.getBreadcrumb();
      },
      immediate: true
    }
  }
};
</script>
<style lang="scss">
.crumbsBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .el-breadcrumb__inner,
  .el-breadcrumb__inner a,
  .el-breadcrumb__inner.is-link {
    font-size: 14px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85) !important;
    line-height: 20px;
  }
}
</style>
